module.exports = __webpack_public_path__ + "static/media/81vW0jAzVfL._AC_SL1500_.97c3aac0.jpg";